import React from 'react';
import Button from '@atlaskit/button';
import { SplitButton } from '@atlaskit/button/new';
import { MoreActionsMenu } from './more-action-menu';

export const EstimateAndOrderActionMenu = ({
  isEstimatePDFDownloading,
  isEstimateJsonIsDownloading,
  onEstimationPDFClick,
  onEstimationJSONClick,
  onClearAllClick,
  onRefreshClick,
  onClickOfReadyToOrder,
  showRefreshOption,
}: {
  isEstimatePDFDownloading: boolean;
  isEstimateJsonIsDownloading: boolean;
  onEstimationPDFClick: () => void;
  onEstimationJSONClick: () => void;
  onClearAllClick: () => void;
  onRefreshClick: () => void;
  onClickOfReadyToOrder: () => void;
  showRefreshOption: boolean;
}) => {
  return (
    <>
      <SplitButton spacing="compact" appearance="primary">
        <Button
          testId="refresh-and-order-button"
          appearance="primary"
          onClick={showRefreshOption ? onRefreshClick : onClickOfReadyToOrder}
        >
          {showRefreshOption ? 'Refresh estimate' : 'Ready to order'}
        </Button>
        <MoreActionsMenu
          isEstimatePDFDownloading={isEstimatePDFDownloading}
          isEstimateJsonIsDownloading={isEstimateJsonIsDownloading}
          onEstimationPDFClick={onEstimationPDFClick}
          onEstimationJSONClick={onEstimationJSONClick}
          onClearAllClick={onClearAllClick}
          hasSplitButtonActionMenu={true}
        />
      </SplitButton>
    </>
  );
};
